var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section-header',{ref:"selectHeader",attrs:{"title":"Select Year"}}),_c('year-selection',{attrs:{"labeledBy":"selectionHeader"}}),_c('app-navigator',{ref:"appNavigator",attrs:{"router":_vm.$router,"nextButtonTitle":"Select one or more years to continue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }